import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UpdateSocialLinks';
// FOR ONE GRAPHQL QUERY
export const UPDATE_SOCIAL_LINKS = defineAsyncActionTypes(`${prefix}/UPDATE_SOCIAL_LINKS`);



// WEBPACK FOOTER //
// ./src/store/graphql/UpdateSocialLinks/action-types.js